import { useEffect } from "react";
import { toast } from "sonner";
import { useTranslations } from "use-intl";
import { useNavigate, useLocation } from "react-router-dom";
import { formatCurrency } from "@/utils/paymentUtils";
import AccountPayablesHeader from "@/components/payments/AccountPayablesHeader";
import PayablesTableSection from "@/components/payments/PayablesTableSection";
import usePayablesData from "@/hooks/usePayablesData";

const AccountPayables = () => {
  const t = useTranslations("consultantPayables.page");
  const location = useLocation();

  // Check for ID parameter in URL
  const searchParams = new URLSearchParams(location.search);
  const paymentId = searchParams.get('id');

  // Use shared payables data hook
  const {
    payables,
    setPayables,
    loading,
    refreshing,
    refreshData,
  } = usePayablesData();

  // Navigation
  const navigate = useNavigate();

  // Handle payment ID parameter (highlight logic, if needed)
  useEffect(() => {
    if (paymentId && payables.length > 0) {
      const matchingInvoice = payables.find(invoice => 
        invoice.id === paymentId || 
        invoice.remittanceInformation === paymentId
      );
      if (matchingInvoice) {
        toast(t("foundTitle"), { description: t("foundBody", { vendor: matchingInvoice.vendor }) });
        setTimeout(() => {
          const element = document.getElementById(`invoice-${matchingInvoice.id}`);
          if (element) {
            element.classList.add('bg-yellow-100', 'border-yellow-400');
            setTimeout(() => {
              element.classList.remove('bg-yellow-100', 'border-yellow-400');
            }, 3000);
          }
        }, 100);
      } else {
        toast.error(t("notFoundTitle"), { description: t("notFoundBody") });
      }
    }
  }, [paymentId, payables]);


  // Show loading state
  if (loading) {
    return (
      <div className="space-y-6">
        <AccountPayablesHeader
          handleRefreshClick={refreshData}
          refreshing={refreshing}
        />
        <div className="flex items-center justify-center h-64">
          <span className="text-xl">{t("loading")}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <AccountPayablesHeader
        handleRefreshClick={refreshData}
        refreshing={refreshing}
      />
      <PayablesTableSection 
        invoices={payables}
        setInvoices={setPayables}
        showTabs={true}
        refreshData={refreshData}
      />
    </div>
  );
};

export default AccountPayables;
